import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as pbi from 'powerbi-client';
import { StudiesService } from '../shared/services/studies.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { HomeService } from '../shared/services/home.service';

@Component({
  selector: 'app-bi-report',
  templateUrl: './bi-report.component.html',
  styleUrls: ['./bi-report.component.scss']
})
export class BiReportComponent implements OnInit {

  report: pbi.Embed;
  // {static: false} part of ViewChild
  @ViewChild('reportContainer') reportContainer: ElementRef;
  studyId: string;

  constructor(
    private biService: StudiesService,
    private sidePanel:SidePanelService,
    private activatedRoute: ActivatedRoute,
    private homeService:HomeService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((studyID) => { this.studyId = studyID.id; });
    this.sidePanel.initSideDrawer(localStorage.getItem('studyTYPE'));
    // this.sidePanel.initSideDrawer(sessionStorage.getItem('studyTYPE'));
    this.homeService.checkRepoDetailsEvent.emit(this.studyId);
    this.sidePanel.getVisibility(this.studyId);
    this.biService.getBIReport(this.studyId).subscribe(
      (data) => {
        // console.log("data ===> ",data)
        this.showReport(data.accessToken, data.embedUrl);
      },
      error => { // error path
        
      }
    );
  }

  showReport(token, url) {
    // let embedReportId = "d0d2dae5-c61a-4301-a0f1-4e53785b6d71";
    let settings: pbi.IEmbedSettings = {
      filterPaneEnabled: false,
      navContentPaneEnabled: false,
    };
    let config: pbi.IEmbedConfiguration = {
      type: 'report',
      tokenType: pbi.models.TokenType.Embed,
      accessToken: token,
      embedUrl: url,
      // id: embedReportId,
      // filters: [],
      // settings: settings
    };
    // console.log("config ======>",config)
    let reportContainer = this.reportContainer.nativeElement;
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    this.report = powerbi.embed(reportContainer, config);
    this.report.off("loaded");
    this.report.on("loaded", () => {
      console.log("Loaded");
      setTimeout(() => {
        window.location.reload();
      }, 2700000);
      //this.setTokenExpirationListener(Token.expiration, 2);
    });
    this.report.on("error", () => {
      console.log("Error");
    });
  }

}
